import React from 'react';

const S = { stroke: '#0E1116', strokeWidth: 2, fill: '#F8FAFC' };
const W = { fill: '#CBD5E1', stroke: '#0E1116', strokeWidth: 1.5 };
const Wheel = ({ cx }) => <g><circle cx={cx} cy={86} r={18} fill="#334155" /><circle cx={cx} cy={86} r={8} fill="#E2E8F0" /></g>;

const Side = () => (
  <g>
    <path d="M14 84 Q10 70 22 64 L70 56 Q92 30 118 24 L196 24 Q220 26 238 52 L278 60 Q292 64 290 84 Z" {...S} />
    <path d="M80 56 Q98 34 120 30 L150 30 L150 56 Z" {...W} /><path d="M158 30 L194 30 Q212 34 228 56 L158 56 Z" {...W} />
    <line x1="154" y1="56" x2="154" y2="84" stroke="#0E1116" strokeWidth="1.2" />
    <Wheel cx={72} /><Wheel cx={232} />
  </g>
);

const Top = () => (
  <g>
    <rect x="96" y="6" width="12" height="12" rx="3" {...S} /><rect x="96" y="112" width="12" height="12" rx="3" {...S} />
    <rect x="12" y="16" width="276" height="98" rx="44" {...S} />
    <path d="M86 26 Q76 65 86 104 L110 98 Q104 65 110 32 Z" {...W} />
    <rect x="112" y="32" width="104" height="66" rx="8" fill="#F1F5F9" stroke="#0E1116" strokeWidth="1.2" />
    <path d="M218 32 Q226 65 218 98 L236 102 Q244 65 236 28 Z" {...W} />
    <text x="164" y="69" textAnchor="middle" fontSize="11" fill="#94A3B8" fontFamily="Arial">DESSUS</text>
  </g>
);

const Face = ({ rear }) => (
  <g>
    <rect x="22" y="104" width="22" height="14" rx="3" fill="#334155" /><rect x="116" y="104" width="22" height="14" rx="3" fill="#334155" />
    <path d="M18 104 L18 70 Q20 58 34 54 L46 26 Q50 18 60 18 L100 18 Q110 18 114 26 L126 54 Q140 58 142 70 L142 104 Z" {...S} />
    <path d="M50 52 L60 26 L100 26 L110 52 Z" {...W} />
    {rear
      ? <><rect x="24" y="64" width="22" height="10" rx="2" fill="#FCA5A5" stroke="#0E1116" /><rect x="114" y="64" width="22" height="10" rx="2" fill="#FCA5A5" stroke="#0E1116" /></>
      : <><circle cx="36" cy="72" r="8" fill="#FEF9C3" stroke="#0E1116" /><circle cx="124" cy="72" r="8" fill="#FEF9C3" stroke="#0E1116" />
        <rect x="58" y="66" width="44" height="14" rx="3" fill="#E2E8F0" stroke="#0E1116" /></>}
    <rect x="64" y="88" width="32" height="9" rx="1" fill="#fff" stroke="#0E1116" />
  </g>
);

export const VIEWS = [
  { key: 'gauche', label: 'Côté gauche', w: 300, h: 120, Shape: Side },
  { key: 'droite', label: 'Côté droit', w: 300, h: 120, Shape: Side, mirror: true },
  { key: 'dessus', label: 'Dessus', w: 300, h: 130, Shape: Top },
  { key: 'avant', label: 'Avant', w: 160, h: 130, Shape: Face },
  { key: 'arriere', label: 'Arrière', w: 160, h: 130, Shape: () => <Face rear /> },
];

export const DAMAGE_TYPES = [
  { key: 'rayure', label: 'Rayure', color: '#F59E0B' }, { key: 'bosse', label: 'Bosse', color: '#2563EB' },
  { key: 'casse', label: 'Cassé', color: '#DC2626' }, { key: 'autre', label: 'Autre', color: '#64748B' },
];
export const typeColor = (t) => (DAMAGE_TYPES.find(d => d.key === t) || DAMAGE_TYPES[3]).color;

export const ViewShape = ({ view }) => {
  const { Shape, mirror, w } = view;
  return <g transform={mirror ? `translate(${w} 0) scale(-1 1)` : undefined}><Shape /></g>;
};

export const Markers = ({ view, damages, selected }) => damages.map((d, i) => d.view !== view.key ? null : (
  <g key={i} transform={`translate(${d.x * view.w} ${d.y * view.h})`}>
    <circle r={selected === i ? 11 : 9} fill={typeColor(d.type)} stroke="#fff" strokeWidth="2" />
    <text y="4" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#fff" fontFamily="Arial">{i + 1}</text>
  </g>
));
